// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions .el-form-item__content{display:flex}.actions .el-form-item__content .el-button{flex:1 1}", ""]);
// Exports
module.exports = exports;
